import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { URLS } from '@wix/da-url';
import EllipsisIcon from '../../../Icons/Ellipsis';
import IconButtonWithContextMenu from '../../../Dropdown/Preset/IconButtonWithContextMenu';
import { BiEventType } from '../../../biLogger';
import s from './MoreMenu.scss';
var MoreMenu = function (_a) {
    var className = _a.className, iconClassName = _a.iconClassName;
    var t = useTranslation().t;
    var items = useMemo(function () { return [
        {
            key: 'groups',
            label: t('siteHeader.groups'),
            link: URLS.GROUPS,
            biData: {
                evid: BiEventType.TOP_NAV_CLICK,
                link_name: 'groups',
                link_url: URLS.GROUPS,
            },
        },
        {
            key: 'shop',
            label: t('siteHeader.shop'),
            link: URLS.SHOP,
            biData: {
                evid: BiEventType.TOP_NAV_CLICK,
                link_name: 'shop',
                link_url: URLS.SHOP,
            },
        },
        {
            key: 'forum',
            label: t('siteHeader.forum'),
            link: URLS.FORUM,
            biData: {
                evid: BiEventType.TOP_NAV_CLICK,
                link_name: 'forum',
                link_url: URLS.FORUM,
            },
        },
    ]; }, [t]);
    return (React.createElement(IconButtonWithContextMenu, { items: items, className: className, popperClassName: s['popper'] },
        React.createElement(EllipsisIcon, { className: iconClassName, disableDefaultColors: true })));
};
MoreMenu.displayName = 'MoreMenu';
export default MoreMenu;
//# sourceMappingURL=MoreMenu.js.map